// Module
var code = "<nav class=\"navbar-implio\" role=\"navigation\"> <eva-navbar-primary></eva-navbar-primary> <eva-banner data-ng-if=\"displayBanner\"></eva-banner> <eva-delete-all-content-notice data-ng-if=\"showDeleteAllContentNotice\"> </eva-delete-all-content-notice> <eva-navbar-secondary data-items=\"vm.nav.secondary\"></eva-navbar-secondary> </nav> ";
// Exports
module.exports = code;